import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getSampleCollectionListSlice } from "../../../store/slices/sampleCollectionSlice";
import SampleCollectionEditModal from "./SampleCollectionEditModal";
import Table from "../../common/Table/table";

const SampleCollection = () => {
  const dispatch = useDispatch();
const {
  sampleCollectionList,
  loading,
  currentPage,
  totalPages,
  totalCount
} = useSelector((state) => state.sampleCollection);
  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinicId = clinicInfo?.[0]?.clinicId;
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
const [pageLimit, setPageLimit] = useState(10);
const fetchSampleCollectionList = useCallback(
  (page = 1, lim = pageLimit) => {
    if (clinicId && token) {
      dispatch(
        getSampleCollectionListSlice({
          clinicId,
          token,
          currentPage: page,
          limit: lim,
        })
      );
    }
  },
  [dispatch, clinicId, token, pageLimit]
);
  useEffect(() => {
    fetchSampleCollectionList();
  }, [fetchSampleCollectionList]);
  const formatDisplayDateTime = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
  };
  const handleEdit = (row) => {
    setSelectedRow(row);
    setShowEditModal(true);
  };
  const handlePageChange = (page) => {
  fetchSampleCollectionList(page, pageLimit);
};
const handleLimitChange = (newLimit) => {
  setPageLimit(newLimit);
  fetchSampleCollectionList(1, newLimit);
};
  const tableHead = [
    { title: "Patient Name", key: "patientName" },
    { title: "UHID", key: "uhid" },
    { title: "Appt Id", key: "appointmentId" },
    { title: "Appt Dt", key: "appointmentDate" },
    { title: "Service", key: "service" },
    { title: "Service Mode", key: "serviceMode" },
    { title: "Service Details", key: "serviceDetails" },
    { title: "Status", key: "status" },
    { title: "Collected By", key: "collectedBy" },
    { title: "Collection Date", key: "collectedDate" },
    { title: "Edit", key: "editBtn" },
  ];
  const filteredList = sampleCollectionList?.filter((item) => {
  if (!fromDate && !toDate) return true;

  const apptDate = new Date(item?.appointmentDate);

  if (fromDate && !toDate) {
    return apptDate >= new Date(fromDate);
  }

  if (!fromDate && toDate) {
    return apptDate <= new Date(toDate + "T23:59:59");
  }

  return (
    apptDate >= new Date(fromDate) &&
    apptDate <= new Date(toDate + "T23:59:59")
  );
});
  const tableBody =
    Array.isArray(filteredList)
      ? filteredList.map((item) => ({
          id: item?.appointmentObjectId,
          patientName: item?.patientName || "N/A",
          uhid: item?.uhid || "N/A",
          appointmentId: item?.appointmentId || "N/A",
          appointmentDate: formatDisplayDateTime(
            item?.appointmentDate
          ),
          service: item?.service || "N/A",
          serviceMode: item?.serviceMode || "N/A",
          serviceDetails: item?.serviceDetails,
          status: item?.status,
          collectedBy: item?.collectedBy,
          collectedDate: formatDisplayDateTime(
            item?.collectedDate
          ),
          discardStatus: item?.discardStatus,
          discardAt: item?.discardAt,
          sampleAge: item?.sampleAge,
          sampleViaType: item?.sampleViaType,
          sampleViaNote: item?.sampleViaNote,
          receivedAt: item?.receivedAt,
          editBtn: (
            <button
              className="btn btn-sm btn-primary"
              onClick={() => handleEdit(item)}
            >
              Edit
            </button>
          ),
        }))
      : [];
  return (
    <div className="container mt-4">
      <div className="d-flex gap-2">
   <input style={{ width: "160px" }} type="date" className="form-control"
    value={fromDate}
    onChange={(e) => setFromDate(e.target.value)}
  />
  <input style={{ width: "160px" }} type="date" className="form-control"
    value={toDate}
    onChange={(e) => setToDate(e.target.value)}
  />
  <button className="btn btn-secondary" onClick={() => {
      setFromDate("");
      setToDate("");
    }}
  >
    Reset
  </button>
</div>
     <Table
  tableHead={tableHead}
  tableBody={tableBody}
  isLoading={loading}
  currentPage={currentPage}
  totalPages={totalPages}
  totalCount={totalCount}
  limit={pageLimit}
  onPageChange={handlePageChange}
  onLimitChange={handleLimitChange}
  showPagination={true}
  showLimitDropdown={true}
/>
      <SampleCollectionEditModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        sampleData={selectedRow}
      />
    </div>
  );
};

export default SampleCollection;